module.exports = __webpack_public_path__ + "static/media/sack-dollar.70be2a3b.svg";